import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-confirmed',
  templateUrl: './auth-confirmed.component.html',
  styleUrls: ['./auth-confirmed.component.css']
})
export class AuthConfirmedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
